import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService, { microServices } from 'network/apis/index'

export const placeBetPlinkoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/plinko/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const demoPlaceBetPlinkoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/plinko/demo-place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsPlinkoService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/plinko/my-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const postLightningBoardDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/plinko/lightning-board-details', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const plinkoGameCheckFairness = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/plinko/check-fairness', data, {
    server: microServices.USER_URL
  })
}
